import React from 'react';
import { motion } from 'framer-motion';

const Templates = () => {
    const templates = [
        { title: "ETL Standard", desc: "Basic Extract, Transform, Load pipeline for data warehouses.", color: "from-blue-500 to-cyan-400" },
        { title: "AI Model Training", desc: "Automated preprocessing and training loop for neural networks.", color: "from-purple-500 to-pink-500" },
        { title: "IoT Swarm Control", desc: "Real-time management for distributed device networks.", color: "from-green-500 to-emerald-400" },
        { title: "FinTech Ledger", desc: "High-frequency transaction processing with audit trails.", color: "from-yellow-400 to-orange-500" },
    ];

    return (
        <div className="min-h-screen bg-cyber-gray text-white font-rajdhani relative overflow-hidden">
            {/* Background Grid Animation */}
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none">
                <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]"></div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-20 relative z-10">
                <motion.div
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.8 }}
                    className="mb-16"
                >
                    <span className="text-green-400 font-mono tracking-widest text-sm uppercase mb-4 block">Pre-Fabricated Constructs</span>
                    <h1 className="text-5xl md:text-7xl font-bold font-orbitron bg-clip-text text-transparent bg-gradient-to-r from-green-400 via-white to-blue-500 mb-6">
                        TEMPLATES
                    </h1>
                    <p className="text-xl text-gray-400 max-w-2xl leading-relaxed">
                        Accelerate deployment with battle-tested pipeline blueprints.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                    {templates.map((template, index) => (
                        <motion.div
                            key={index}
                            initial={{ opacity: 0, rotateX: 90 }}
                            animate={{ opacity: 1, rotateX: 0 }}
                            transition={{ delay: index * 0.2, type: "spring" }}
                            whileHover={{ scale: 1.02 }}
                            className="relative group cursor-pointer"
                        >
                            <div className={`absolute inset-0 bg-gradient-to-r ${template.color} rounded-xl blur opacity-25 group-hover:opacity-60 transition-opacity duration-500`}></div>
                            <div className="relative bg-gray-900 border border-gray-700 p-8 rounded-xl h-full flex flex-col justify-between overflow-hidden">
                                <div>
                                    <h3 className="text-2xl font-bold font-orbitron mb-3 group-hover:text-white transition-colors">{template.title}</h3>
                                    <p className="text-gray-400 group-hover:text-gray-200 transition-colors">{template.desc}</p>
                                </div>
                                <div className="mt-8 flex items-center text-sm font-mono text-gray-500 group-hover:text-white transition-colors">
                                    <span>{/* INITIALIZE_SEQUENCE */}INITIALIZE_SEQUENCE</span>
                                    <div className="ml-auto w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Templates;
